import { useLayoutEffect, useState } from 'react';

import { Phone, Hours } from '~components/AllianceCallService/AllianceCallService';
import Button from '~components/Button/Button';
import FormDisclaimer from '~components/FormDisclaimer/FormDisclaimer';
import EmailLeadForm from '~components/LeadForm/EmailLeadForm/EmailLeadForm';
import Modal from '~components/ModalDialog/ModalDialog';
import useWindowSize from '~hooks/useWindowSize';
import success from '~images/badges/check_blue_success.svg';
import BookIcon from '~images/inline/book-decorative.inline.svg';

const NtmGuideModal = () => {
    const [isSucceeded, setIsSucceeded] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const { width } = useWindowSize();

    useLayoutEffect(() => {
        setIsDesktop(width >= 1024);
    }, [width]);

    const handleSuccess = () => {
        setIsSucceeded(true);
    };

    return (
        <div>
            <button
                className="flex items-end font-bold text-primary border-b border-link"
                data-wa-link="Medicare Guide"
                data-qa="medicare-guide"
                onClick={() => setIsOpen(true)}
            >
                <span>Get the free New to Medicare Guide </span>
                <BookIcon className="pl-1 text-primary text-28" />
            </button>

            <Modal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                title={
                    isDesktop || !isSucceeded
                        ? 'Get the New to Medicare Guide straight to your inbox'
                        : null
                }
            >
                {!isSucceeded ? (
                    <>
                        <p className="text-base mb-4 md:mb-6 md:text-lg">
                            Spend more time learning about Medicare offline with our New to Medicare
                            eBook. Send yourself a PDF of our guide. You&apos;ll get all of the
                            information you&apos;ll find on our New to Medicare page in a stylized
                            eBook that&apos;s not only an easy read but clear and uncomplicated.
                        </p>
                        <EmailLeadForm
                            uid="sticky-email-cta"
                            mktoFormId={1004}
                            isStacked={false}
                            errorTextColor="text-red"
                            leadInfo={{ advertiseSource: 'NTMGuide' }}
                            qaInput="sticky-email-textbox"
                            onSuccess={handleSuccess}
                        />
                        <FormDisclaimer className="mt-6" />
                    </>
                ) : (
                    <div className="success-view text-center">
                        <img alt="check mark" src={success} className="mx-auto" />
                        <p className="font-bold my-3 text-xl md:block md:text-2xl">
                            Yay! Your New to Medicare Guide is on its way
                        </p>
                        <p className="mb-6 text-base md:mx-auto md:text-lg">
                            If you don&apos;t see an email from us in the next 30 minutes, be sure
                            to check your spam folder. If you have any questions in the meantime
                            feel free to get in touch with one of our agents.
                        </p>
                        <div>
                            <Phone islink={!isDesktop} classname="font-bold text-lg md:text-2xl" />
                            <span className="mb-4 text-lg md:text-2xl font-bold"> TTY 711</span>
                        </div>
                        <Hours isinline={false} classname="text-lg" />
                        <div className="w-full pt-4">
                            <Button onClick={() => setIsOpen(false)} className="w-full md:w-1/2">
                                Close
                            </Button>
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default NtmGuideModal;
